export class DateFormatUtil {
    static dateTh(date) {
        let result = '';
        if(date) {
            const dateSplit = date.split('-');
            // const months = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'];
            const months = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
            const day = parseInt(dateSplit[2]);
            const month = months[parseInt(dateSplit[1]) - 1];
            const year = parseInt(dateSplit[0]) + 543;
            result = `${day} ${month} ${year}`;
        }
        return result;
    }
}
